/**
 * Semen stallion types.
 * Matches C# SemenStallionType enum.
 */
export const SemenStallionType = {
    Fresh: 'Fresh',
    Frozen: 'Frozen',
    LiveFoal: 'LiveFoal',
};
